import { z } from "zod";
import { STATUS_EVENTO } from "../dominio";
import { dia, id } from "./comuns";

const eventoBase = z.object({
  nome: z.string().trim().min(2, { error: "Informe o nome do evento" }).max(160),
  dataInicio: dia,
  dataFim: dia,
  local: z.string().trim().max(160).nullable(),
  status: z.enum(STATUS_EVENTO),
  permiteEstoqueNegativo: z.boolean(),
});

const periodoValido = (v: { dataInicio?: string; dataFim?: string }) =>
  !v.dataInicio || !v.dataFim || v.dataFim >= v.dataInicio;
const erroPeriodo = { error: "A data de fim não pode ser antes do início", path: ["dataFim"] };

export const eventoCriarSchema = eventoBase
  .extend({
    local: eventoBase.shape.local.optional().default(null),
    status: eventoBase.shape.status.optional().default("PLANEJADO"),
    permiteEstoqueNegativo: z.boolean().optional().default(false),
  })
  .refine(periodoValido, erroPeriodo);
export type EventoCriarEntrada = z.input<typeof eventoCriarSchema>;

export const eventoEditarSchema = eventoBase
  .partial()
  .refine((v) => Object.keys(v).length > 0, { error: "Nada para alterar" })
  .refine(periodoValido, erroPeriodo);
export type EventoEditarEntrada = z.input<typeof eventoEditarSchema>;

/** Exclusão de evento com histórico: nome digitado + senha do ADMIN. Sem histórico, vazio. */
export const eventoExcluirSchema = z.object({
  confirmacaoNome: z.string().trim().max(200).optional(),
  senha: z.string().max(200).optional(),
});
export type EventoExcluirEntrada = z.input<typeof eventoExcluirSchema>;

export const cardapioDefinirSchema = z.object({
  produtoIds: z.array(id).max(500),
});
export type CardapioDefinirEntrada = z.input<typeof cardapioDefinirSchema>;
